module.exports = __webpack_public_path__ + "static/media/attention.322f39dd.svg";